import styled from "styled-components";

export const SectionHeading = styled.h3`
  margin: 0;
  align-self: flex-start;
`;

export const SectionDescription = styled.div`
  font-size: 1rem;
  margin-bottom: 0;
  text-align: left;
  width: 100%;
`;
